export default __webpack_public_path__ + "static/posthog-plugins-90944f27258ed64ac9804c0d0f30b928.png";